module.exports = "{{this.data.message}}"